import axios from "axios";
import { getOswUrl } from "config/configUtils";
import useAppSelector from "hooks/useAppSelector";
import { useCallback, useState } from "react";

type Props = {
  currency: string;
  tenantReference: string;
  emailAddress: string;
};

export const usePostInitPaymentOSW = () => {
  const sessionId = useAppSelector((state) => state.authentication.sessionId);

  const [data, setData] = useState();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState();

  const postInitPaymentOSW = useCallback(
    async ({ currency, tenantReference, emailAddress }: Props) => {
      setLoading(true);
      let initialError = null;
      const URL = `${getOswUrl()}/api/payments/opp/init`;

      const response = await axios
        .post(
          URL,
          {
            currency,
            tenantReference,
            emailAddress,
          },
          {
            headers: {
              SessionId: sessionId,
            },
          }
        )
        .catch((error) => {
          setError(error);
          initialError = error;
        });

      setData(response?.data);
      setLoading(false);

      return { responseData: response?.data, error: initialError };
    },
    [sessionId]
  );

  return { postInitPaymentOSW, data, loading, error };
};
